import { apiClient } from './api';
import type { SqueezoResponse, SqueezoHistoryResponse } from '../types/squeezo';

export const squeezoService = {
  /**
   * Get latest Squeezo value
   * GET /api/jdash/squeezo/latest/
   */
  async getLatest(): Promise<SqueezoResponse> {
    return apiClient.get<SqueezoResponse>('/api/jdash/squeezo/latest/');
  },

  /**
   * Create a new Squeezo entry (admin only)
   * POST /api/jdash/squeezo/create_entry/
   * Requires jdash_access permission
   * This automatically broadcasts to WebSocket subscribers
   */
  async createEntry(value: number): Promise<SqueezoResponse> {
    return apiClient.post<SqueezoResponse>('/api/jdash/squeezo/create_entry/', { value });
  },

  /**
   * Get recent Squeezo history
   * GET /api/jdash/squeezo/history/?limit=N
   */
  async getHistory(limit: number = 20): Promise<SqueezoHistoryResponse> {
    return apiClient.get<SqueezoHistoryResponse>(`/api/jdash/squeezo/history/?limit=${limit}`);
  },
};
